
const decimalToHex = decimal => (`0${decimal.toString(16)}`).substr(-2);

const generateId = (length) => {
  const array = new Uint8Array((length || 20) / 2);
  window.crypto.getRandomValues(array);
  return Array.from(array, decimalToHex).join('');
};

const tryJsonParse = (item) => {
  try {
    return JSON.parse(item);
  } catch (e) {
    return {};
  }
};

export default {
  setItemWithId(key, value) {
    const keyId = `${key}-${generateId()}`;
    sessionStorage.setItem(keyId, value);
    return keyId;
  },
  replaceItemWithId(key, value) {
    const stringifyFilter = JSON.stringify(value);
    sessionStorage.setItem(key, stringifyFilter);
  },
  getItem(key) {
    return sessionStorage.getItem(key);
  },
  getJsonObject(key) {
    const storageItem = sessionStorage.getItem(key);
    return tryJsonParse(storageItem);
  },
  removeItem(key) {
    sessionStorage.removeItem(key);
  },
};
